function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M17.594 0H1.403C.627 0 0 .612 0 1.37v16.257C0 18.384.627 19 1.403 19h16.19C18.37 19 19 18.384 19 17.63V1.37C19 .611 18.37 0 17.594 0zM5.637 16.19h-2.82V7.122h2.82v9.07zM4.227 5.887a1.634 1.634 0 11-.006-3.268 1.634 1.634 0 01.006 3.268zM16.19 16.19h-2.817v-4.409c0-1.05-.018-2.404-1.466-2.404-1.465 0-1.688 1.146-1.688 2.33v4.483H7.407V7.12h2.702v1.24h.037c.374-.713 1.295-1.466 2.664-1.466 2.854 0 3.38 1.878 3.38 4.32v4.976z",
  fill: "#fff"
});

function SvgLinkedin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default SvgLinkedin;